import React, { useContext } from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react";

import TeamStandings from "./TeamStandings";

export const TeamStandingsStatistics = observer(
	function TeamStandingsStatistics() {
		const store = useContext(OfferStoreContext) as
			| EventViewStore
			| AdditionalOfferViewStore;

		if (store.displayStatisticsGroup === StatisticsGroups.TeamStandings) {
			return (
				<ErrorBoundaryWithPropagation componentName="Desktop/TeamStandingStatistics.tsx">
					<TeamStandings store={store} />
				</ErrorBoundaryWithPropagation>
			);
		}
		return null;
	}
);
